import React, { useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "../../ui/dialog";

export default function DialogModal({
    open,
    setOpen,
    title,
    Child,
    onClose = () => { },
    Footer = () => <div />,
    className,
    contentClassName,
    contentStyle,
}) {
    useEffect(() => {
        if (!open) {
            onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    if (!Child) {
        return null;
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className={className}>
                <DialogHeader>
                    <DialogTitle className="text-base font-medium">{title}</DialogTitle>
                </DialogHeader>
                <div 
                    className={`dialog-modal-content max-h-[70vh] overflow-y-auto ${contentClassName || ''}`}
                    style={{
                        scrollbarWidth: 'thin',
                        scrollbarColor: '#0b1a38 #f3f4f6',
                        ...(contentStyle || {}),
                    }}
                >
                    <style>
                        {`
                            .dialog-modal-content::-webkit-scrollbar {
                                width: 6px;
                            }
                            .dialog-modal-content::-webkit-scrollbar-track {
                                background: #f3f4f6;
                                border-radius: 10px;
                            }
                            .dialog-modal-content::-webkit-scrollbar-thumb {
                                background: #d1d5db;
                                border-radius: 10px;
                            }
                            .dialog-modal-content::-webkit-scrollbar-thumb:hover {
                                background: #9ca3af;
                            }
                        `}
                    </style>
                    <Child />
                </div>

                <DialogFooter className="mt-1 gap-2">
                    <Footer />
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
